import { AbstractScatterWinProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractScatterWinProperties";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { BitmapTextFieldProperties } from "@lib/titan2/dist/game/control/properties/BitmapTextFieldProperties";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameLang } from "../lang/GameLang";
import { GameBitMapFontStyle } from "../style/GameBitMapFontStyle";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
export class GameScatterWinProperties extends AbstractScatterWinProperties {
    constructor() {
        super();
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, true);
        this.animationProperties = new SpineProperties(GameStyle.SCATTER_WIN_ANIMATION, GameStyle.MODULE);
        this.counterProperties = new TextFieldProperties(GameFontStyle.WIN_ANIMATION_COUNTER, new Point(0, -50), null, null, ControlConstants.TOP, new Point(1024, 200));
        this.counterTimes = [3, 4, 5, 6];
        /** @deprecated. If these are not defined, Titans ScatterWin class errors*/
        this.title0Properties = new TextFieldProperties(GameFontStyle.WIN_ANIMATION_TITLE_0);
        /** @deprecated. If these are not defined, Titans ScatterWin class errors*/
        this.title1Properties = new TextFieldProperties(GameFontStyle.WIN_ANIMATION_TITLE_0);
        this.winProperties = {
            text: new TextFieldProperties(GameFontStyle.WIN_ANIMATION_TITLE_0, new Point(0, 50), GameLang.WIN, undefined, ControlConstants.BOTTOM, new Point(1024, 200)),
            image: new SpriteProperties(GameStyle.WIN_FANCY, SlingoStyle.MODULE, new Point(0, -75), new Point(0.75, 0.75), new Point(0.5, 0.5)),
            targetText: "Win"
        };
        this.bigWinProperties = {
            text: new TextFieldProperties(GameFontStyle.WIN_ANIMATION_TITLE_1, new Point(0, 50), GameLang.BIGWIN, undefined, ControlConstants.BOTTOM, new Point(1024, 200)),
            image: new SpriteProperties(GameStyle.BIG_WIN_FANCY, SlingoStyle.MODULE, new Point(0, -125), new Point(0.75, 0.75), new Point(0.5, 0.5)),
            targetText: "Big Win",
        };
        this.epicWinProperties = {
            text: new TextFieldProperties(GameFontStyle.WIN_ANIMATION_TITLE_2, new Point(0, 50), GameLang.EPICWIN, undefined, ControlConstants.BOTTOM, new Point(1024, 200)),
            image: new SpriteProperties(GameStyle.EPIC_WIN_FANCY, SlingoStyle.MODULE, new Point(0, -125), new Point(0.75, 0.75), new Point(0.5, 0.5)),
            targetText: "Epic Win",
        };
        this.megaWinProperties = {
            text: new TextFieldProperties(GameFontStyle.WIN_ANIMATION_TITLE_3, new Point(0, 50), GameLang.MEGAWIN, undefined, ControlConstants.BOTTOM, new Point(1024, 200)),
            image: new SpriteProperties(GameStyle.MEGA_WIN_FANCY, SlingoStyle.MODULE, new Point(0, -125), new Point(0.75, 0.75), new Point(0.5, 0.5)),
            targetText: "Mega Win",
        };
        this.titlePosition = new Point();
        this.lowWinAnimationProperties = new SpineProperties(GameStyle.SUMMARY_PANEL, GameStyle.MODULE, undefined, new Point(0.7, 0.7));
        this.lowWinTitleProperties = new TextFieldProperties(GameFontStyle.SCATTER_WIN_ANIMATION_TITLE, new Point(0, -164), GameLang.RESULT, null, null, new Point(1024, 200));
        this.lowWinCounterProperties = new TextFieldProperties(GameFontStyle.SCATTER_WIN_ANIMATION_COUNTER, new Point(0, -50), null, null, null, new Point(1024, 200));
        this.bitmapCounter = {
            textField: new TextFieldProperties(GameFontStyle.WIN_ANIMATION_COUNTER, new Point(0, -50), null, null, ControlConstants.TOP, new Point(1024, 200)),
            //A bug where BitMapText does not seem to center correctly without size defined. Bug is in checkBounds
            bitmapField: new BitmapTextFieldProperties(GameBitMapFontStyle.COUNTER, GameFontStyle.WIN_ANIMATION_COUNTER, new Point(0, 0), null, ControlConstants.CENTER, ControlConstants.TOP, new Point(20000, 200)),
        };
        //The font is very large, but we dont want to use the built in bounding because that will make the text jump in size as the counter increases.
        //Instead the entire text will be scaled
        this.bitmapCounter.bitmapField.scale.set(0.55);
    }
    equals(other) {
        return deepEquals(this, other);
    }
}
//# sourceMappingURL=GameScatterWinProperties.js.map